var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00003 15.8914L9.54089 15.282C10.1546 14.5797 10.7069 13.9114 11.1977 13.2771L11.6032 12.7423C13.2963 10.4617 14.1429 8.65225 14.1429 7.31396C14.1429 4.45796 11.8406 2.14282 9.00003 2.14282C6.15946 2.14282 3.85718 4.45796 3.85718 7.31396C3.85718 8.65225 4.70375 10.462 6.39689 12.7431L6.80232 13.278C7.50308 14.1757 8.23613 15.0468 9.00003 15.8914Z",
    stroke: "#3E3E3F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00003 9.42854C10.1835 9.42854 11.1429 8.46915 11.1429 7.28568C11.1429 6.10221 10.1835 5.14282 9.00003 5.14282C7.81657 5.14282 6.85718 6.10221 6.85718 7.28568C6.85718 8.46915 7.81657 9.42854 9.00003 9.42854Z",
    stroke: "#3E3E3F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.85ea2f319c7bf2e7af23ac59b0692a00.svg";
export { ForwardRef as ReactComponent };